import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Auth from '@aws-amplify/auth';
import Amplify from 'aws-amplify';

//userPoolWebClientId: '4geumjch625hcrn1vc5082sfi3',
//userPoolId: 'eu-west-1_QjmwUHjmS',

Amplify.configure({
    Auth: {
        // REQUIRED - Amazon Cognito Identity Pool ID
        identityPoolId: 'eu-west-1:fba22738-6965-4bf4-8dc0-fb69c88ef18d',
        // REQUIRED - Amazon Cognito Region
        region: 'eu-west-1',
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'eu-west-1_Wh7s7OpJZ',
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: '62bend39g4uqm85hj22inmj1bv',
    },
    API: {
        endpoints: [
            {
                name: "MyAPIGatewayAPI",
                endpoint: "https://kkakn861c8.execute-api.us-east-2.amazonaws.com/dev",
                //endpoint: "https://0yntnk73o1.execute-api.eu-west-1.amazonaws.com/prod",
                custom_header: async() => { return { Authorization: (await Auth.currentSession()).idToken.jwtToken }}
                //endpoint: "https://x8bn66rbg8.execute-api.eu-west-1.amazonaws.com/prod"
                //endpoint: "https://xfop0elosf.execute-api.eu-west-1.amazonaws.com/Dev"
                //endpoint: "https://p31gnsomd8.execute-api.eu-west-1.amazonaws.com/dev",
            }
        ]
    }
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
